import Loading from "assets/lottie/loading";

interface Props { }

const LoadingView: React.FC<Props> = () => {
  return (
    <div className=" w-screen h-screen bg-transparent ">
      <div className="w-full h-full relative">
        <Loading isCenter />
      </div>
    </div>
  );
};

export default LoadingView;
